import React, { useState, useEffect ,useContext} from 'react'
import style from '../../../styles/mystyle.module.css'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'next-i18next'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import IconButton from '@mui/material/IconButton'
import { constants } from '../../../constants'
import Link from 'next/link'
import { useRouter } from "next/router";
import getOffers from '../../helpers/offers'
import { styled } from "@mui/system"
import { useCart } from "../../../context/cart/use-cart";
import { getCookieValue } from '../../helpers/helpers'
import AddIcon from "@mui/icons-material/Add"
import * as config from '../../../next.config'
import CurrencyContext from '../../../context/currencyProvider'
import MinusIcon from "@mui/icons-material/Remove"
import QuantityDialog from "../Dialogs/QuantityDialog"
import { CustomeCard , CustomeCardMedia ,
  CustomeCardActions , CustomeCardContent ,
   CustomeIconbtn , CustomeCheckbox} from "./Product.style"
   import Checkbox from "@mui/material/Checkbox"
   import { useMedia } from "../../../utils/use-media";
   import OtherUnitsPrice from '../Home/OtherUnitsPrice'
// const CustomeCard = styled(Card)({
//   width: "100%",
//   height: "240px",
//   position: 'relative',
//   margin: 'auto',
//   "@media (min-width:280px) and (max-width:300px)": {
//     height: "256px",
//   },
//   '@media (min-width:768px) and (max-width:912px)': {
//     width: "100%",
//     height: "291px",
//     position: 'relative',
//     margin: 'auto'
//   },
//   '@media (min-width:913px) ': {
//     width: "100%",
//     height: "294px",
//     position: 'relative',
//     margin: 'auto'
//   }
// })
// const CustomeCardMedia = styled(CardMedia)({
//   width: "100% !important",
//   height: "100px !important",
//   objectFit: " contain !important",
//   "@media (min-width:280px) and (max-width:300px)": {
//     height: "120px !important",
//   },
//   '@media (min-width:768px) and (max-width:912px)': {
//     width: "100% !important",
//     height: "140px !important",
//     objectFit: " contain !important",
//   },
//   '@media (min-width:913px) ': {
//     width: "100% !important",
//     height: "140px !important",
//     objectFit: " contain !important",
//   }
// })
// const CustomeCardActions = styled(CardActions)(({ locale }) => ({
//   gap: "0rem",
//   justifyContent: "space-between",
//   padding: "0px ",
//   flexDirection: "column",
//   marginLeft: "0 !important",
//   marginRight: "0 !important",
//   alignItems: locale == "ar" ? "flex-start" : "flex-start",
//   "&.MuiCardActions-root>:not(:first-of-type)": {
//     marginLeft: "0 !important",
//     marginRight: "0 !important",
//     width: "100%",
//   },
//   '@media (min-width:768px) and (max-width:912px)': {
//     gap: "2rem",
//     justifyContent: "space-around",
//     padding: "0px"
//     ,
//     "&.MuiCardActions-root>:not(:first-of-type)": {
//       marginLeft: "0 !important",
//       marginRight: "0 !important",
//       width: "100%",
//     }
//     ,
//   },
//   '@media (min-width:913px) ': {
//     gap: "0rem",
//     justifyContent: "space-around",
//     padding: "0px 0px 16px 0px",
//   },
// }))
// const CustomeCardContent = styled(CardContent)({
//   padding: "0px 8px",
//   '& .MuiTypography-root':
//     { color: "black" },
//   '@media (min-width:768px) and (max-width:912px)': {
//     '& .MuiCardContent-root': {
//       padding: "16px"
//     },
//   },
//   '@media (min-width:913px) ': {
//     padding: "0px 8px",
//   }
// })
// const CustomeIconbtn = styled(IconButton)({
//   "&.MuiIconButton-root:hover": {
//     backgroundColor: "transparent !important"
//   },
//   width: "100% ",
//   borderRadius: "0% !important",
// });
function OfferProducts({ data, exchangeCurrenciesRes, currencies, localStorageEle }) {
  const [productItem, setProductItem] = useState({ ...data })
  const { t } = useTranslation("common");
  const currency= useContext(CurrencyContext)
  useEffect(() => {
    if (data) {
      setProductItem(data)
    }
  }, [data])
  const mobile = useMedia("(max-width: 580px)");
  const { addItem, removeItem, isInCart, getItem, items } = useCart();
  const router = useRouter();
  const {locale} = useRouter();
  const [DataQuantityDialog,setDataQuantityDialog]=useState({open:false,entityDetailsId:null,productUnitPriceId:null,productId:null,quantity:null})
  const [otherPricesDialog, setOtherPricesDialog] = React.useState({ data: null, open: false })
  return (
    <>
      {productItem ?
          <div>
                  {DataQuantityDialog.open?
        <QuantityDialog open={DataQuantityDialog.open}
        productId={DataQuantityDialog.productId}
        productUnitPriceId={DataQuantityDialog.productUnitPriceId}
        entityDetailsId={DataQuantityDialog.entityDetailsId}
        quantity={DataQuantityDialog.quantity}
                btnOk={() => {
                
                  setDataQuantityDialog({
                    open: false
                }) 
                }} 
                btnCancel={() => {
                
                  setDataQuantityDialog({
                    open: false
                })   
                }}
              />:""}
               {otherPricesDialog.open ?
        <OtherUnitsPrice data={otherPricesDialog.data} onClose={() => setOtherPricesDialog({ ...otherPricesDialog, open: false })} productUnitPriceList={[]} open={otherPricesDialog.open} currency={currency} /> : ""}
            <div className={style.allcard + " "}>
              <CustomeCard>
              <div className={style.markandheartproduct}>
                    <img className={style.markproduct} src={`${config.basePath}/assest/Myfav.svg`} ></img>
                    <CustomeCheckbox
                      icon={<img className={style.StarBorderDiet + " " + style.heartproduct}
                        src={`${config.basePath}/assest/OutlineStar.svg`} ></img>
                      }
                      checked={getItem(productItem.id, null,    productItem.entityDetailsId, getCookieValue("userCountry")) != null && getItem(productItem.id, null,    productItem.entityDetailsId, getCookieValue("userCountry")).isFavoriate == true}
                      checkedIcon={<img className={style.StarDiet + " " + style.heartproduct}
                        src={`${config.basePath}/assest/Fullstar.svg`} ></img>
                      }
                      className={style.heartproduct}
                      onClick={(e) => {
                        if (e.target.checked == true) {
                          addItem({
                            type: "products",
                            entityId:productItem.id,
                            isFavoriate: true,
                            quantity: 0,
                            productUnitPrice: null,
                            entityDetailsId: productItem.entityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        }
                         else if (e.target.checked == false) {
                          removeItem({
                            type: "products",
                            entityId:productItem.id,
                            isFavoriate: false,
                            quantity: 0,
                            productUnitPrice: null,
                            entityDetailsId:productItem.entityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        }
                      }}
                    /></div>
                <Link className={style.AtagIcon + " " + style.hoverLink + " " + style.ColorBlack}
                  href={`/${constants.productUrl}/${productItem.productId}/${productItem.productUnitPriceId}`} passHref >
                   <CustomeCardMedia
                      component="img"
                      sx={{ 1000: { height: "380", width: "380" }, 400: { height: "350", width: "350" } }}
                      image={
                        productItem.images && productItem.images.length > 0 && productItem.images[0] &&
                        productItem.images[0].image && productItem.images[0].image != null && productItem.images[0].image != "" ?
                        productItem.images[0].image
                          :
                          `${config.basePath}/assest/logo.svg`
                      }

                      alt="image"
                    />
                </Link>
                <CustomeCardContent>
                    <Link className={style.AtagIcon + " " + style.hoverLink + " " + style.ColorBlack}
                      href={`/${constants.productUrl}/${productItem.productId}/${productItem.id}`} passHref >
                      <Typography fontWeight="600" gutterBottom variant="h5" component="div" marginBottom={0}>
                        {mobile ?
                          productItem.product[0].transProduct.find(r=>r.language&&r.language.code==router.locale) != null && productItem.product[0].transProduct.find(r=>r.language&&r.language.code==router.locale).name.length >= 15 ? productItem.product[0].transProduct.find(r=>r.language.code==router.locale).name.substr(0, 15) + "..." : productItem.product[0].transProduct[0].name
                          :
                          productItem.product[0].transProduct.find(r=>r.language&&r.language.code==router.locale) != null && productItem.product[0].transProduct.find(r=>r.language&&r.language.code==router.locale).name.length >= 20 ? productItem.product[0].transProduct.find(r=>r.language.code==router.locale).name.substr(0, 20) + "..." : productItem.product[0].transProduct[0].name
                        }
                        {" "}
                        {productItem.units && productItem.units.length && productItem.units.filter(i => i.language.code == router.locale).length > 0 ? `(${productItem.units && productItem.units.filter(i => i.language.code == router.locale)[0].name})` : ""}

                      </Typography>
                    </Link>
                    <Typography gutterBottom variant="h5" component="div">
                      {/* {console.log("x=========>",item.entityDetails[0].transEntityDetails.filter(z=>z.language.length>0
                          &&z.language[0].code==router.locale)[0].officialName)} */}
                      {mobile ?
                        productItem.entityDetails && productItem.entityDetails.length > 0 ? productItem.entityDetails[0].transEntityDetails.filter(z=>z.language.length>0
                          &&z.language[0].code==router.locale)[0].officialName.length >= 22 ? productItem.entityDetails[0].transEntityDetails.filter(z=>z.language.length>0
                            &&z.language[0].code==router.locale)[0].officialName.substr(0, 22) + "... " :
                            productItem.entityDetails[0].transEntityDetails.filter(z=>z.language.length>0
                            &&z.language[0].code==router.locale)[0].officialName: ""
                        :
                        productItem.entityDetails && productItem.entityDetails.length > 0 
                        &&productItem.entityDetails[0].transEntityDetails.filter(z=>z.language.length>0
                          &&z.language[0].code==router.locale).length>0 ? productItem.entityDetails[0].transEntityDetails.filter(z=>z.language.length>0
                          &&z.language[0].code==router.locale)[0].officialName.length >= 28 ? productItem.entityDetails[0].transEntityDetails.filter(z=>z.language.length>0
                            &&z.language[0].code==router.locale)[0].officialName.substr(0, 28) + "... " :
                            productItem.entityDetails[0].transEntityDetails.filter(z=>z.language.length>0
                              &&z.language[0].code==router.locale)[0].officialName: ""
                      }
                    </Typography>
                  </CustomeCardContent>

                {/* <CustomeCardActions>
                  {(() => {
            if (productItem.offer && productItem.offer.length>0 ) {
                      return <>
                        <div className={style.DisCountSquare}>
                          <div className={style.SquareOffer}>{t("offer")}</div>
                        </div>
                      </>
                    }
                  })()} */}
                  {/* {(() => {
                    let hasOffer = false
                    let prodOffer = null
                    let offerCurrency = null
                    let Precentage = 0
                    hasOffer = true
                    // console.log("productItem================>",productItem)
                    if( productItem.offer && productItem.offer.length>0){
                      prodOffer = getOffers(productItem.offer[0].fixedPrecentage,productItem.productUnitPricePrice,productItem.offer[0].fixedAmount)
                    Precentage = ((productItem.offer&& productItem.offer.length>0&& productItem.offer[0].fixedPrecentage) + (productItem.offer&& productItem.offer.length>0&&productItem.offer[0].fixedAmount / productItem.productUnitPricePrice) * 100)
                  }
                    let getExchangeCurrency = currency.exchangeCurrencyRes && currency.exchangeCurrencyRes.filter(ele => ele.from == productItem.productUnitPriceCurrency.id && ele.to == currency.currency)
                    if(getExchangeCurrency&&getExchangeCurrency.length>0){
                      getExchangeCurrency=getExchangeCurrency[0].exchangedAmount
                    }
                    else{
                      getExchangeCurrency=currency.exchangeCurrencyRes.length>0?currency.exchangeCurrencyRes.filter(ele=>ele.from==productItem.productUnitPriceCurrency.id)[0].exchangedAmount:1
                    }
                    if(currency.currenciesLst.filter(ele=>ele.id==currency.currency).length>0){
                   
                      offerCurrency= currency.currenciesLst.filter(ele=>ele.id==currency.currency)[0].transCurrency.filter(ele=>ele.language.code==router.locale)[0].currencySymbol
                    }
                    else{
                      offerCurrency=currency.currenciesLst.filter(ele=>ele.local==true)[0].transCurrency.filter(ele=>ele.language.code==router.locale)[0].currencySymbol
                    }
                    return <>
                      {productItem.productUnitPriceDisplayPrice &&productItem.productUnitPriceDisplayPrice==true?<div className={style.PriceOffer + " " + style.paddingTextProduct}>
                       
                        {prodOffer!=null ? <p className={style.textPriceProduct}>
                          {(prodOffer * getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                          {" "}
                          {offerCurrency}
                        </p> : ""}
                        <div className={style.flex + " " + style.halfGap}>
                          {prodOffer == productItem.productUnitPricePrice ? " " :
                            <p className={style.textPriceProduct}
                            style={{ textDecoration: productItem.offer && productItem.offer.length? "line-through":"none", textDecorationColor:  productItem.offer && productItem.offer.length>0?"#F52A59":"none",color:  productItem.offer&&productItem.offer.length>0?"#F52A59":"none" }}
                            >
                              {(productItem.productUnitPricePrice * getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                              {" "}
                              {offerCurrency}
                            </p>
                          }
                          <div className={style.paddingOffer}>
                            {Precentage > 0 ?
                              <div className={style.DisSquareOffer + " " + style.widthOffer}>{(Precentage).toFixed(2) + "-" + " %"}</div>
                              : ""}
                          </div>
                        </div>
                      </div>:t("priceHiddin")}
                    </>
                  })()} */}
                  {/* <br /> */}
                  {/* <div className={style.AddCart} >
                    {isInCart(
                      productItem.productId,
                      "products",
                      productItem.productUnitPriceId,
                      productItem.productUnitPriceEntityDetailsId,
                      getCookieValue("userCountry")
                    ) ?
                      <div className={style.DivCount + " " + style.fullwidth + " " + style.borderteal + " " + style.borderRadius}>
                        <div><CustomeIconbtn className={style.Count + " " + " " + style.paddingZero} onClick={e =>
                          addItem({
                            type: "products",
                            entityId: productItem.productId,
                            isFavoriate: false,
                            quantity: 1,
                            productUnitPrice: productItem.productUnitPriceId,
                            entityDetailsId: productItem.productUnitPriceEntityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        } >
                          <div className={style.bordercount + " " + style.FlexPM}><AddIcon className={style.sizeAdIc} /></div></CustomeIconbtn></div>
                          <button  className={style.Count + " " + style.borderRadius} onClick={e=>{setDataQuantityDialog({productId: productItem.productId,productUnitPriceId: productItem.productUnitPriceId,entityDetailsId:  productItem.productUnitPriceEntityDetailsId,open:true,quantity:getItem( productItem.productId,  productItem.productUnitPriceId, productItem.productUnitPriceEntityDetailsId, getCookieValue("userCountry")) != null ? getItem( productItem.productId,  productItem.productUnitPriceId,   productItem.productUnitPriceEntityDetailsId, getCookieValue("userCountry")).quantity:null})}}>
                            <p style={{ marginBottom: 0, fontWeight: 600 }}>{getItem(
                          productItem.productId,
                          productItem.productUnitPriceId,
                          productItem.productUnitPriceEntityDetailsId,
                          getCookieValue("userCountry")
                        ) != null
                          ? getItem(
                            productItem.productId,
                            productItem.productUnitPriceId,
                            productItem.productUnitPriceEntityDetailsId,
                            getCookieValue("userCountry")
                          ).quantity
                          : ""}</p></button>
                        <div><CustomeIconbtn className={style.Count + " " + " " + style.paddingZero} onClick={e =>
                          removeItem({
                            type: "products",
                            entityId: productItem.productId,
                            isFavoriate: false,
                            quantity: 1,
                            productUnitPrice: productItem.productUnitPriceId,
                            entityDetailsId: productItem.productUnitPriceEntityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        } >
                          <div className={style.bordercount + " " + style.FlexPM}><MinusIcon className={style.sizeAdIc} /></div></CustomeIconbtn></div>
                      </div>
                      :
                      <button className={style.btnAdd + " " + style.fullwidth + " " + style.paddingAddCartPro + " " + style.borderRadius}
                        onClick={e =>
                          addItem({
                            type: "products",
                            entityId: productItem.productId,
                            isFavoriate: false,
                            quantity: 1,
                            productUnitPrice: productItem.productUnitPriceId,
                            entityDetailsId: productItem.productUnitPriceEntityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        }><AddIcon className={style.sizeAdIc} />{t("add")}</button>}
                  </div> */}
                {/* </CustomeCardActions> */}
                
                <CustomeCardActions>
                    {(() => {

                      if (productItem.offer && productItem.offer.length > 0) {
                        return <>
                          <div className={style.DisCountSquare}>
                            <div className={style.SquareOffer}>{t("offer")}</div>
                          </div>
                        </>
                      }
                    })()}
                    {(() => {
                      if (productItem.displayPrice) {
                        let prodOffer = null
                        let offerCurrency = null
                        let Precentage = 0
                        let getExchangeCurrency = currency ? currency.exchangeCurrencyRes && currency.exchangeCurrencyRes.filter(ele => ele.from == productItem.currency.id && ele.to == currency.currency) : 1

                        if (getExchangeCurrency && getExchangeCurrency.length > 0) {
                          getExchangeCurrency = getExchangeCurrency[0].exchangedAmount
                        }
                        else {
                          getExchangeCurrency = currency.exchangeCurrencyRes && currency.exchangeCurrencyRes.filter(ele => ele.from == productItem.currency.id && ele.to == props.currencies.filter(ele => ele.local == true)[0].id)
                          if (getExchangeCurrency && getExchangeCurrency.length > 0) {
                            getExchangeCurrency = getExchangeCurrency[0].exchangedAmount
                          }


                        }
                        if (currency.currenciesLst.filter(ele => ele.id == currency.currency).length > 0) {
                          offerCurrency = currency.currenciesLst.filter(ele => ele.id == currency.currency)[0].transCurrency.filter(ele => ele.language.code == locale)[0].currencySymbol
                        }
                        else {
                          if (currency.currenciesLst.length > 0) {
                            offerCurrency = currency.currenciesLst.filter(ele => ele.local == true)[0].transCurrency.filter(ele => ele.language.code == locale)[0].currencySymbol

                          }
                        }
                        if (productItem.offer && productItem.offer.length > 0) {
                          prodOffer = getOffers(
                            productItem.offer && productItem.offer[0].fixedPrecentage,
                            productItem.price,
                            productItem.offer && productItem.offer[0].fixedAmount
                          )
                          Precentage = ((productItem.offer && productItem.offer[0].fixedPrecentage) + (productItem.offer && productItem.offer[0].fixedAmount / productItem.price) * 100)
                        }
                        return <>
                          <div className={style.PriceOffer + " " + style.paddingTextProduct}>
                            {prodOffer != null ? <p className={style.textPriceProduct}>
                              {(prodOffer * getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                              {" "}

                              {offerCurrency}
                            </p> : ""}
                            <div className={style.flex + " " + style.halfGap}>
                              {productItem.offer && productItem.offer.length > 0 && prodOffer == productItem.price ? " " :
                                <p className={style.textPriceProduct}
                                  style={{ textDecoration: productItem.offer && productItem.offer.length ? "line-through" : "none", textDecorationColor: productItem.offer && productItem.offer.length > 0 ? "#F52A59" : "none", color: productItem.offer && productItem.offer.length > 0 ? "#F52A59" : "none" }}
                                >
                                  {(productItem.price * getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                  {" "}
                                  {offerCurrency}
                                </p>
                              }
                              <div className={style.paddingOffer}>
                                {Precentage > 0 ?
                                  <div className={style.DisSquareOffer + " " + style.widthOffer}>{(Precentage).toFixed(2) + "-" + " %"}</div>
                                  : ""}
                              </div>
                            </div>
                          </div>
                        </>
                      } else {
                        return <p className={style.textPriceProduct}>
                          {t("priceHiddin")}
                        </p>
                      }
                    })()}
                    <br />
                    {/* {console.log("item2======>", item)} */}

                    <div className={style.AddCart}  >
                      {(() => {
                        if (productItem && productItem.ProductUnitPriceFeatures && productItem.ProductUnitPriceFeatures.length > 0) {

                          return <button className={style.btnAdd + " " + style.fullwidth + " " + style.paddingAddCartPro + " " + style.borderRadius}
                            onClick={() => {
                              // setOpenDailog(true)
                              setOtherPricesDialog({ ...otherPricesDialog, open: true, data: { ...productItem, productUnitPrice: [{ ...productItem }] } })

                            }}

                          >   {<><AddIcon /> {t("add")}</>} </button>

                        }
                        else {
                          if (isInCart(
                            productItem.productId,
                            "products",
                            productItem.id,
                            productItem.entityDetailsId,
                            getCookieValue("userCountry")
                          )) {
                            return <div className={style.DivCount + " " + style.fullwidth + " " + style.borderteal + " " + style.borderRadius}>
                              <div><CustomeIconbtn className={style.Count + " " + " " + style.paddingZero} onClick={e =>
                                addItem({
                                  type: "products",
                                  entityId: productItem.productId,
                                  isFavoriate: false,
                                  quantity: 1,
                                  productUnitPrice: productItem.id,
                                  entityDetailsId: productItem.entityDetailsId,
                                  userCountry: getCookieValue("userCountry")
                                })
                              } >
                                <div className={style.bordercount + " " + style.FlexPM}><AddIcon className={style.sizeAdIc} /></div></CustomeIconbtn></div>
                                <button className={style.Count + " " + style.borderRadius} onClick={e => { setDataQuantityDialog({ productId: productItem.productId, productUnitPriceId:    productItem.id, entityDetailsId:   productItem.entityDetailsId, open: true, quantity: getItem(productItem.productId,productItem.id,productItem.entityDetailsId, getCookieValue("userCountry")) != null ? getItem(productItem.productId,productItem.id,productItem.entityDetailsId, getCookieValue("userCountry")).quantity : null }) }}>
                                <p style={{ marginBottom: 0, fontWeight: 600 }}>{getItem(
                                  productItem.productId,
                                  productItem.id,
                                  productItem.entityDetailsId,
                                  getCookieValue("userCountry")
                                ) != null
                                  ? getItem(
                                    productItem.productId,
                                    productItem.id,
                                    productItem.entityDetailsId,
                                    getCookieValue("userCountry")
                                  ).quantity
                                  : ""}</p></button>
                              <div><CustomeIconbtn className={style.Count + " " + " " + style.paddingZero} onClick={e =>
                                removeItem({
                                  type: "products",
                                  entityId: productItem.productId,
                                  isFavoriate: false,
                                  quantity: 1,
                                  productUnitPrice: productItem.id,
                                  entityDetailsId: productItem.entityDetailsId,
                                  userCountry: getCookieValue("userCountry")
                                })
                              } >
                                <div className={style.bordercount + " " + style.FlexPM}><MinusIcon className={style.sizeAdIc} /></div></CustomeIconbtn></div>
                            </div>
                          }
                          else {
                            return <button className={style.btnAdd + " " + style.fullwidth + " " + style.paddingAddCartPro + " " + style.borderRadius}
                              onClick={e =>
                                addItem({
                                  type: "products",
                                  entityId: productItem.productId,
                                  isFavoriate: false,
                                  quantity: 1,
                                  productUnitPrice: productItem.id,
                                  entityDetailsId: productItem.entityDetailsId,
                                  userCountry: getCookieValue("userCountry")
                                })
                              }><AddIcon className={style.sizeAdIc} />{t("add")}</button>
                          }

                        }
                      })()}

                    </div>
                  </CustomeCardActions>
              </CustomeCard>
            </div></div>
          : ""
      }
    </>

  )
}

export default OfferProducts


